module.exports = __webpack_public_path__ + "media/images/dropdown-circle-a3bdcd4c.svg";